import { useMemo } from 'react';
import { OnboardingStepKeyEnum } from '../../../components/Onboarding';
import { ActiveIntegration } from '../../../pages/Settings/Integrations/Integrations.types';
import IntegrationGuideModal from './IntegrationGuideModal';
import { Guider, GuiderStepConfig } from '../../../shared/molecules/Guider/Guider';

export function IntegrationGuide(props: { handleIntegrationClick: (id: ActiveIntegration, complete: () => void) => void }) {
  // Define steps
  const steps: GuiderStepConfig[] = useMemo(
    () => [
      {
        key: "about_workitem",
        divId: '[data-onboarding-id="integration-header"]',
        renderModal: ({ isOpen, onClose }) => (
          <IntegrationGuideModal
            isOpen={isOpen}
            onClose={onClose}
            onSelectIntegration={(id) => props.handleIntegrationClick(id, onClose)}
            singleStep={true}
          />
        ),
        placement: "bottom" as const,
      },
      {
        key: "about_page",
        divId: '[data-onboarding-id="integration-header"]',
        message: "Here you can manage all of the available integrations",
        placement: "bottom" as const,
      },
      {
        key: "about_workitem_2",
        divId: '[data-onboarding-id="integration-header"]',
        renderModal: ({ isOpen, onClose }) => (
          <IntegrationGuideModal
            isOpen={isOpen}
            onClose={onClose}
            onSelectIntegration={(id) => props.handleIntegrationClick(id, onClose)}
            initialStep={1}
          />
        ),
        placement: "bottom" as const,
      },
    ],
    [props],
  );

  return (
    <Guider
      onboardingKey={OnboardingStepKeyEnum.Integrations}
      steps={steps}
    />
  );
}